import { render, staticRenderFns } from "./finance-profit-report-category.vue?vue&type=template&id=3a585ecd&scoped=true&"
import script from "./finance-profit-report-category.vue?vue&type=script&lang=js&"
export * from "./finance-profit-report-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a585ecd",
  null
  
)

export default component.exports